import axios from "axios";

export function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function normalizeAuthToken(token) {
  if (!token || typeof token !== 'string') return token;

  try {
    return decodeURIComponent(token);
  } catch (error) {
    return token;
  }
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export async function getUser(token) {
  const config = {
    headers: {
      'Authorization': normalizeAuthToken(token)
    }
  };
  const response = await axios.get(`${process.env.VUE_APP_API_URL}/users/me`, config);
  return response.data;
}

export async function getDemoUsers() {
  const response = await axios.get(`${process.env.VUE_APP_API_URL}/demo/users`);
  return response.data;
}

export async function demoLogin(email, demoKey) {
  const payload = { email };

  if (demoKey) {
    payload.demoKey = demoKey;
  }

  const response = await axios.post(
    `${process.env.VUE_APP_API_URL}/demo/login`,
    payload
  );

  return response.data;
}

export async function startDemoWorkRefresh(demoKey, seedDate) {
  const payload = {};

  if (demoKey) {
    payload.demoKey = demoKey;
  }

  if (seedDate) {
    payload.seedDate = seedDate;
  }

  const response = await axios.post(
    `${process.env.VUE_APP_API_URL}/demo/work/refresh`,
    payload
  );

  return response.data;
}

export async function getDemoWorkRefreshJob(jobId, demoKey) {
  const config = {};

  if (demoKey) {
    config.params = { demoKey };
  }

  const response = await axios.get(
    `${process.env.VUE_APP_API_URL}/demo/work/refresh/${jobId}`,
    config
  );

  return response.data;
}

export async function getLatestDemoWorkRefresh(demoKey) {
  const config = {};

  if (demoKey) {
    config.params = { demoKey };
  }

  const response = await axios.get(
    `${process.env.VUE_APP_API_URL}/demo/work/refresh/latest`,
    config
  );

  return response.data;
}


export async function createNotification(token, notifiedUser, recordId, message, type, link, timestamp) {
  // console.log('createNotification is running', token, recordId, message, type, link, timestamp);
  const notification = {
    recordId: recordId,
    notifiedUser: notifiedUser,
    message: message,
    type: type,
    link: link,
    timestamp: timestamp || new Date().toISOString()
  };
  console.log('notification', notification);

  if (!token) {
    console.error('No token provided for notification');
    return null;
  }

  if (!notification.recordId || !notification.notifiedUser || !notification.message || !notification.type || !notification.link) {
    console.error('Notification is missing required fields:', notification);
    return null;
  }

  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_URL}/users/notifications`,
      notification,
      {
        headers: {
          'Authorization': normalizeAuthToken(token)
        }
      }
    );

    console.log('Notification created successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating notification:', error);
    return null;
  }
}
